import { Vue } from 'vue-property-decorator'
import { LOCALES, Locales } from '@/i18n/locales'

function normalizeLocale (locale: any): string | null {
  return (locale == null || locale === '') ? null : String(locale).split('-')[0].toLowerCase()
}

function supportedLocale (locale: string | null): boolean {
  return locale != null && LOCALES.some(item => item.value === locale)
}

export function checkLanguage (fallbackLocale: string): string {
  const cookies = (Vue as any).$cookies
  const cookieLocale = normalizeLocale(cookies == null ? null : cookies.get('rcLanguage'))
  const browserLocale = (navigator.language == null) ? null : normalizeLocale(navigator.language)
  const fallback = normalizeLocale(fallbackLocale)
  console.log('Fallback locale ' + fallbackLocale)
  console.log('Cookie locale ' + cookieLocale)
  console.log('Browser locale ' + browserLocale)
  const locale = [cookieLocale, browserLocale, fallback].find(supportedLocale) || Locales.EN
  console.log('Set locale ' + locale)
  return locale
}
